<ng-container *ngIf="isLoading; else content">
    <div class="commodity-cls">
        <p-card>
            <div class="grid m-0">
                <div class="md:col-1 sm:col-12 p-0">
                    <p-skeleton width="93%" height="1.5rem"></p-skeleton>
                </div>
            </div>
            <br>
            <div class="grid m-0">
                <div class="md:col-2 sm:col-12 p-0">
                    <p-skeleton width="5rem" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="93%" height="1.8rem"></p-skeleton>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <p-skeleton width="5rem" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="93%" height="1.8rem"></p-skeleton>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <p-skeleton width="5rem" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="96%" height="1.8rem"></p-skeleton>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <p-skeleton width="5rem" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="96%" height="1.8rem"></p-skeleton>
                </div>
                <div class="md:col-3 sm:col-12 p-0">
                    <p-skeleton width="5rem" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="96%" height="1.8rem"></p-skeleton>
                </div>
            </div>
            <br>
            <div class="grid m-0">
                <div class="md:col-1 sm:col-12 p-0 ml-3">
                    <p-skeleton width="100%" height="2rem" styleClass="mb-1"></p-skeleton>
                </div>
                <div class="md:col-1 sm:col-12 p-0 ml-3">
                    <p-skeleton width="100%" height="2rem" styleClass="mb-1"></p-skeleton>
                </div>
            </div>
            <br>
            <div class="grid m-0 ">
                <div class="md:col-12 sm:col-12 p-0">
                    <p-skeleton width="100%" height="5rem"></p-skeleton>
                </div>
            </div>
            <br>
            <div class="md:col-1 sm:col-12 p-0 ml-3">
                <p-skeleton width="100%" height="2rem" styleClass="mb-1"></p-skeleton>
            </div>
        </p-card>
    </div>
</ng-container>

<neo-matris-dialog [visible]="showMaterialDialog" [maximizable]="true" (onHide)="closeMaterialDialog()" [header]="'Add Material Group '">
    <div [ngStyle]="{'pointer-events': blockUI ? 'none' : 'auto'}" #dialogContent>
        <div class="grid m-0">
        <div class="md:col-3  sm:col-12 p-0">
            <neo-matris-input [height]="'55%'" [inputWidth]="'93%'" [value]="materialGroupId" 
            label="Material Group Id" (valueChange)="onMaterialGroupIdChange($event)">
            </neo-matris-input>
        </div>
        <div class="md:col-3  sm:col-12 p-0">
            <neo-matris-input [height]="'55%'" [inputWidth]="'93%'" label="Description"
            [value]="materialGroupName" (valueChange)="onMaterialGroupNameChange($event)">
            </neo-matris-input>
        </div>
        <div class="md:col-3  sm:col-12 p-0">
            <neo-matris-input [height]="'55%'" [inputWidth]="'93%'" label="Material Group No"
            [value]="materialGroup" (valueChange)="onMaterialGroupChange($event)">
            </neo-matris-input>
        </div>
        <div class="md:col-3 sm:col-12 p-0" style="margin-top: 1.25rem;">
            <neo-matris-button (buttonClick)="searchMaterial()" [buttonText]="'Search'"
            [buttonStyle]="{'height': '85%'}">
            </neo-matris-button>
        </div>
        </div>
        <neo-matris-table
            [showTableSkeleton]="showMaterialTableSkeleton" [first]="firstMaterial" [showPaginator]="true" (checkboxChange)="onMaterialTableSelection($event)"
            [showEmptyMessage]="true" [totalRecords]="totalCountMaterial" (pageChange)="onMaterialPageChange($event)" 
            [isFooterVisible]="true" [loading]="false" [rows]="rowsMaterial" [selectionMode]="'multiple'" [columns]="materialColumns">        
        </neo-matris-table>
    </div>
    <br>
    <div class="grid m-0">
      <div class="md:col-1 sm:col-12 p-0">
        <neo-matris-button [buttonText]="'OK'" (buttonClick)="confirmMaterial()" [buttonStyle]="{'height': '85%'}">
        </neo-matris-button>

      </div>
    </div>
</neo-matris-dialog>

<ng-template #content>
    <div class="commodity-cls" [ngStyle]="{'pointer-events': blockUI ? 'none' : 'auto'}">
        <p-card>
            <ng-template pTemplate="header">
                <div class="supplier-header" style="display: flex; align-items: center; gap: 8px;">
                    <i class="pi pi-arrow-left"
                        style="font-size: 16px; cursor: pointer; margin-left: 8px;"
                        (click)="goBack()">
                    </i>
                    <span style="font-family: 'Scania Sans Headline', sans-serif; font-weight: 700;">
                        Profile
                    </span>
                </div>
            </ng-template>
            <div class="grid m-0">
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-input 
                        [label] = "'Name'" 
                        [id] = "'name'" 
                        [value] = "formatName(name)"
                        [height]="'55%'" 
                        [inputWidth]="'93%'"
                        [isInputDisabled]="true" >
                    </neo-matris-input>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-input 
                        [label] = "'Email Address'" 
                        [id] = "'email'" 
                        [value] = "username"
                        [height]="'55%'" 
                        [inputWidth]="'93%'"
                        [isInputDisabled]="true" >
                    </neo-matris-input>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-input 
                        [label] = "'Purchaser Code'" 
                        [id] = "'purchaserCode'" 
                        [value] = "userPurchaserCode"
                        [height]="'55%'" 
                        [inputWidth]="'93%'"
                        [isInputDisabled]="true" >
                    </neo-matris-input>
                </div>
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-input 
                        [label] = "'Brand'" 
                        [id] = "'brand'" 
                        [value] = "userOrg"
                        [height]="'55%'" 
                        [inputWidth]="'93%'"
                        [isInputDisabled]="true" >
                    </neo-matris-input>
                </div>
                <div class="md:col-3 sm:col-12 p-0">
                    <neo-matris-input 
                        [label] = "'Title'" 
                        [id] = "'title'" 
                        [value] = "title"
                        (valueChange)="onTitleChange($event)"
                        [height]="'55%'" 
                        [inputWidth]="'93%'" >
                    </neo-matris-input>
                </div>
            </div>
            <br>
            <div class="grid m-0">
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-button
                        [buttonText]="'Add Row'" 
                        [buttonStyle]="{'height': '75%'}" 
                        (buttonClick)="addRow()"
                        id="add">
                    </neo-matris-button>
                    &nbsp;
                    <neo-matris-button
                        [buttonText]="'Remove Row'" 
                        [buttonStyle]="{'height': '75%'}" 
                        [disabled]="selectedRows.length === 0"
                        (buttonClick)="removeRow()"
                        id="remove">
                    </neo-matris-button>
                </div>
            </div>
            <div *ngIf="isMissingMtrlGrpId || isOldData" class="grid m-0">
                <div class="col-12 text-right" style="font-size:11px; line-height:1.2;">
                    <span *ngIf="isMissingMtrlGrpId"
                        style="color:#fe0303;font-weight:500;margin-right:20px;">
                        ■ Missing Material Group ID
                    </span>

                    <span *ngIf="isOldData"
                        style="color:#856404;font-weight:500;">
                        ■ Data older than 1 year
                    </span>

                </div>
            </div>
            <neo-matris-table
                [showTableSkeleton]="showTableSkeleton"
                [showPaginator]="showPaginator"
                [showEmptyMessage]="true"
                [separateRowAndCheckboxClick]="true"
                [first]="first"
                [isFooterVisible]="true"
                [totalRecords]="totalCount"
                (tableDropdownChange)="onFunctionChange($event)"
                (checkboxChange)="onProfileTableSelection($event)"
                [selectedRow]="selectedRows"
                (pageChange)="onPageChange($event)"
                [rows]="rows"
                [columns]="columns"
                [selectionMode]="'multiple'">
            </neo-matris-table>
            <br>
            <div class="grid m-0">
                <div class="md:col-2 sm:col-12 p-0">
                    <neo-matris-button
                        [buttonText]="'Save'"
                        [loading]="isSaving"
                        [buttonStyle]="{'height': '75%'}"
                        (buttonClick)="saveProfile()">
                    </neo-matris-button>
                </div>
            </div>
        </p-card>
    </div>
</ng-template>